import { type FC, type PropsWithChildren, useEffect } from 'react';

import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container, Snackbar } from '@crehana/ui';

import HeaderLight from '@/views/AdminDashboard/components/HeaderLight';

import { Footer } from './components';
import { useExcelImporterStepperContext } from './context';
import { useGetStepsWithFallback } from './hooks';
import type { ExcelImporterStepperProps } from './types';

const ExcelImporterStepper: FC<
  PropsWithChildren<ExcelImporterStepperProps>
> = ({ title, backLabel, children }) => {
  const { t } = useTranslation();
  const steps = useGetStepsWithFallback(children);
  const {
    totalSteps,
    handleSetSteps,
    currentStep,
    setSnackbar,
    snackbar,
    panelUrl,
    isContentOnly,
    isDark,
  } = useExcelImporterStepperContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    handleSetSteps(Object.keys(steps).length);
  }, [steps]);

  const mainBg = isDark
    ? 'text-white bg-base-dark'
    : 'text-base-main bg-gray-lighter';

  if (isContentOnly) {
    return <>{steps[currentStep]}</>;
  }

  return (
    <>
      <div className={`${mainBg} flex flex-col w-full h-screen`}>
        <HeaderLight
          isDark={isDark}
          backUrl={panelUrl}
          title={title || t('HEADER_TITLE')}
          backLabel={backLabel || t('HEADER_BACK')}
        />
        <div className="h-full overflow-auto">
          <Container className="flex flex-col items-center h-full">
            {steps[currentStep]}
          </Container>
        </div>
        {currentStep < totalSteps && <Footer />}
      </div>
      <Snackbar
        isDark={isDark}
        position="top-right"
        dismissOnDelay={3000}
        dismissOnClickOutside
        onDismiss={() => setSnackbar({})}
        {...(snackbar as object)}
      />
    </>
  );
};

export default ExcelImporterStepper;
